import TwelveLaboursFooter from './src/TwelveLaboursFooter';

/* istanbul ignore next */
TwelveLaboursFooter.install = function(Vue) {
  Vue.component(TwelveLaboursFooter.name, TwelveLaboursFooter);
};


export default TwelveLaboursFooter
